import { i18nTranslationHelper } from '@/i18n'
import BiotechOutlinedIcon from '@mui/icons-material/BiotechOutlined'
import MenuBookOutlined from '@mui/icons-material/MenuBookOutlined'
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined'
import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined'
import SquareFootOutlinedIcon from '@mui/icons-material/SquareFootOutlined'
import TranslateOutlinedIcon from '@mui/icons-material/TranslateOutlined'
import WorkspacePremiumOutlinedIcon from '@mui/icons-material/WorkspacePremiumOutlined'
import { IconProps, SvgIconTypeMap } from '@mui/material'
import { OverridableComponent } from '@mui/material/OverridableComponent'

export namespace Category {
  const t = i18nTranslationHelper.getTEnums
  export class Enum {
    static readonly COURSE = new Enum(
      1,
      'COURSE',
      t('enrollmentCategories.course.label'),
      1,
      MenuBookOutlined
    )

    static readonly LANGUAGE = new Enum(
      2,
      'LANGUAGE',
      t('enrollmentCategories.language.label'),
      6,
      TranslateOutlinedIcon
    )

    static readonly UNDERGRADUATE = new Enum(
      3,
      'UNDERGRADUATE',
      t('enrollmentCategories.underGraduate.label'),
      4,
      SchoolOutlinedIcon
    )

    static readonly GRADUATE = new Enum(
      4,
      'GRADUATE',
      t('enrollmentCategories.graduate.label'),
      5,
      WorkspacePremiumOutlinedIcon
    )

    static readonly MENTORING = new Enum(
      5,
      'MENTORING',
      t('enrollmentCategories.mentoring.label'),
      7,
      PeopleAltOutlinedIcon
    )
    static readonly TECHNICAL = new Enum(
      9,
      'TECHNICAL',
      t('enrollmentCategories.technical.label'),
      3,
      BiotechOutlinedIcon
    )
    static readonly HIGH_SCHOOL = new Enum(
      10,
      'HIGH_SCHOOL',
      t('enrollmentCategories.highSchool.label'),
      2,
      SquareFootOutlinedIcon
    )

    public constructor(
      public readonly id: number,
      public readonly name: string,
      public readonly title: string,
      public readonly sequence: number,
      public readonly icon?: OverridableComponent<SvgIconTypeMap<object, 'svg'>>
    ) {}

    public get Icon() {
      return this.icon as React.ComponentType<IconProps>
    }

    public isAvailable(restricted: Category.Enum[]): boolean {
      return !restricted || !restricted.includes(this)
    }

    is(subtype: Category.Enum | null): boolean {
      return this.id === subtype?.id
    }
  }

  export const getAvailables = (restricted?: Category.Enum[]): Enum[] => {
    return Object.values(Category.Enum)
      .filter(category => category.isAvailable(restricted))
      .sort((a: Category.Enum, b: Category.Enum) => a.sequence - b.sequence)
  }

  export const getById = (id: number): Enum => {
    return Object.values(Category.Enum).find(category => category.id === id)
  }

  export const getByName = (name: string): Enum => {
    return Object.values(Category.Enum).find(category => category.name === name)
  }

  /**
   * @deprecated Use Category.getByName instead
   */
  export const deprecatedGetByTitle = (title: string): Enum => {
    return Object.values(Category.Enum).find(
      category => category.title.toLowerCase() === title.toLowerCase()
    )
  }
}
